import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { connectHits } from "react-instantsearch-core";
import axios from "axios";
import PropertyCard, { SingleProperty } from "./PropertyCard/PropertyCard";
import { useLocation } from "@reach/router"

const SearchBanner = (props) => {
    const [propItems, setPropItems] = useState([]);
    const location = useLocation();
    useEffect(() => {
        // featured properties
        // let sale = this
        let sale = location.pathname.includes("for-sale")
        let url = process.env.GATSBY_STRAPI_SRC + `/stb-lists/item/featured-properties${sale?"-sales":"-let"}/`;
        getItems(url)
    }, []);

    const getItems = async url => {
        try {
            const { data } = await axios.get(url, {
                headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_AT}`,
                }})
            if (data && data.length > 0) {
                setPropItems(data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    return (
            <Container>
                {props.hits.length === 0 && 
                    <div  className="no-results-page">
                        <div className="row h-100 align-items-center">
                            <div className="col-md-12">
                                <h5 className="text-center my-3">Unfortunately, we do not currently have any properties that match your search criteria.</h5>
                            </div>
                            <div className="col-md-12 mt-0">
                                <p className="text-center results-page-wrapper">We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
                                {propItems.map((each, i) => 
                                    <SingleProperty
                                        hit={each}
                                        key={i}
                                        strapi={true}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                }
            </Container>
    )
};
export default connectHits(SearchBanner)